import { ParsedUrlQuery } from 'querystring';

export function getBillsIncluded(query: ParsedUrlQuery) {
    if (query['bills_included']) {
        return query['bills_included'];
    }

    return '';
}
